import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import VueAxios from "vue-axios";
import VueAuth from "@websanova/vue-auth";
import UUID from "vue-uuid";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/fr";
import vuexI18n from "vuex-i18n";
import localesFr from "./i18n/fr";
import helpers from "./util/helpers";
import filters from "./util/filters";
import store from "./store";
import Theme from "./theme";
import VueYouTubeEmbed from "vue-youtube-embed";
import VueClipboard from "vue-clipboard2";

// Plugins
import App from "./App.vue";

// router setup
import routes from "./routes";
// plugin setup
Vue.use(VueRouter);
Vue.use(Theme);
Vue.use(ElementUI, { locale });
Vue.use(UUID);
Vue.use(vuexI18n.plugin, store);
Vue.i18n.add("fr", localesFr);
Vue.i18n.set("fr");
Vue.use(VueYouTubeEmbed);
Vue.use(VueClipboard);

// configure router
const router = new VueRouter({
  routes,
  linkActiveClass: "active",
  hashbang: true,
  mode: "history",
  beforeRouteEnter: (to, from, next) => {
    console.log(to);
    next();
  },
});
Vue.router = router;

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
Vue.use(VueAxios, axios);
Vue.use(VueAuth, {
  auth: require("./auth/jwt.js"),
  http: require("@websanova/vue-auth/drivers/http/axios.1.x.js"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x.js"),
  parseUserData: function (res) {
    return res.results;
  },
  refreshData: {
    url: "auth/refresh",
    method: "GET",
    enabled: true,
    interval: 1,
  },
});

// Register filters
Object.keys(filters).map(function (key) {
  Vue.filter(key, filters[key]);
});

Vue.prototype.$env = process.env;
Vue.config.productionTip = false;
Vue.prototype.$helpers = helpers;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  store,
});
